export default __webpack_public_path__ + "static/city-ec09ac67eafeebf065d26d7881464c5d.png";